/**
 * HSL_RANGES — per-color hue band [centerHueDeg, halfWidthDeg].
 * Used by the HSL panel (per-colour Hue/Sat/Lum) and by the render kernel.
 *
 * Centers track standard color-wheel positions. Half-width controls how much
 * a pixel's hue smoothly blends with neighbours (smoothstep falloff in the
 * kernel) — so e.g. an orange pixel at hue 45° picks up some of the Orange
 * band's Sat/Lum shift but also some of Red's, weighted by distance.
 */
export const HSL_RANGES = {
    Red:     [0,    30],
    Orange:  [30,   30],
    Yellow:  [60,   30],
    Green:   [120,  60],
    Cyan:    [180,  30],
    Blue:    [240,  40],
    Magenta: [300,  40],
};
